/**
 * Varování u malých vzorků (spec 08 §1).
 *
 * Prahy zrcadlí core/stats.py: < 1 000 impresí nebo < 30 kliků v kterékoli větvi.
 * Varování se NESMÍ dát odkliknout pryč — je to součást výsledku, ne notifikace.
 */
import { checkSmallSample, comparisonWarnings, type AnyComparison } from '@/lib/significance';

export interface SmallSampleWarningProps {
  comparison?: AnyComparison | null;
  successes?: number | null;
  trials?: number | null;
  label?: string;
  /** kompaktní ikona do buňky tabulky místo celého bloku */
  inline?: boolean;
}

export function SmallSampleWarning({
  comparison,
  successes,
  trials,
  label = 'Vzorek',
  inline = false,
}: SmallSampleWarningProps) {
  const warnings = comparison
    ? comparisonWarnings(comparison)
    : checkSmallSample(successes, trials, label).warnings;

  if (warnings.length === 0) return null;

  if (inline) {
    return (
      <span
        className="small-sample small-sample--inline"
        title={warnings.join('\n')}
        aria-label={`Varování: ${warnings.join(' ')}`}
      >
        <WarnIcon />
      </span>
    );
  }

  return (
    <div className="small-sample" role="note">
      <WarnIcon />
      <div className="small-sample__body">
        <strong>Malý vzorek</strong>
        <ul>
          {warnings.map((warning) => (
            <li key={warning}>{warning}</li>
          ))}
        </ul>
      </div>
    </div>
  );
}

function WarnIcon() {
  return (
    <svg
      className="small-sample__icon"
      viewBox="0 0 16 16"
      width="16"
      height="16"
      aria-hidden="true"
      focusable="false"
    >
      <path
        d="M8 1.5 15 14H1L8 1.5Z"
        fill="none"
        stroke="currentColor"
        strokeWidth="1.4"
        strokeLinejoin="round"
      />
      <path d="M8 6v4" stroke="currentColor" strokeWidth="1.4" strokeLinecap="round" />
      <circle cx="8" cy="12" r="0.8" fill="currentColor" />
    </svg>
  );
}
